export interface CommandStatus {
  message: string;
  status: CommandStatusType;
  type: CommandType;
}

export enum CommandStatusType {
  NotInitiated,
  Pending,
  Success,
  Failure,
  Error
}

export enum CommandType {
  Lockdown = 'Lockdown',
  Release = 'Release'
}
